module.exports = __webpack_public_path__ + "static/media/noun_Before After_576653.a2e3cc75.svg";